import { render } from "./home.vue?vue&type=template&id=4984f4ed"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=4984f4ed&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/_DKRx8o2/0/web/speechki_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__